import { MatterType } from '@/matter/store/schemas'
import type { MatterRead, MatterReadForTable } from '@/matter/store/schemas'

/**
 * Returns true if the matter is the legacy unassigned matter.
 *
 * This matter is read-only and contains content that was not assigned to a matter before
 * migrating to the matter-centric architecture where all resources must belong to a matter.
 */
export function isUnassignedMatter(matter: MatterRead | MatterReadForTable | null | undefined): boolean {
  return matter?.type === MatterType.LEGACY_UNASSIGNED
}
